import { createFileRoute } from "@tanstack/react-router";
import { ErrorComponent } from "../components/Routing/Error";

export const Route = createFileRoute("/error")({
  component: ErrorComponent,
  staticData: { titleKey: "errors.title" },
});
